<template>
    <div class="title-bar dsp-flex" v-bind:class="className">
        <div class="title-side title-gray">
            <span v-if="titleData.showCancel" @click.passive="clickCancel">取消</span>
            <span v-else @click.passive="clickBack"><i class="iconfont icon-xiangzuo"></i></span>
        </div>
        <div class="title-middle">{{titleData.titleText}}</div>
        <div v-if="titleData.hideButton || !titleData.saveButton" class="title-side title-green" v-bind:class="{'title-green-gray':createGray}" @click.passive="clickCreate">{{titleData.titleCreate}}</div>
        <div v-else class="title-side title-green" @click.passive="clickSave">
            <span class="title-save-button">保存</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TitleBar',
    props: {
        className: {
            type: String,
            default() {
                return ''
            }
        },
        titleData: {
            type: Object,
            default() {
                return {}
            }
        },
        backFunc: {
            type: Function,
            default() {
                return function() {}
            }
        },
        cancelFunc: {
            type: Function,
            default() {
                return function() {}
            }
        },
        createFunc: {
            type: Function,
            default() {
                return function() {}
            }
        },
        createGray: {
            type: Boolean,
            default() {
                return false
            }  
        },
        saveFunc: {
            type: Function,
            default() {
                return function() {}
            }
        },
        readFunc: {
            type: Function,
            default() {
                return function() {}
            }
        },
    },
    methods:{
        clickBack() {
            if(this.backFunc && typeof(this.backFunc) == 'function'){
                this.backFunc();
            }
        },
        clickCancel() {
            if(this.cancelFunc && typeof(this.cancelFunc) == 'function'){
                this.cancelFunc();
            }
        },
        clickCreate() {
            if(this.createFunc && typeof(this.createFunc) == 'function'){
                this.createFunc();
            }
        },
        clickSave() {
            if(this.saveFunc && typeof(this.saveFunc) == 'function'){
                this.saveFunc();
            }
        },
        clickRead() {
            if(this.readFunc && typeof(this.readFunc) == 'function'){
                this.readFunc();
            }
        }
    }
}
</script>